import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, switchMap, filter } from 'rxjs/operators';
import { ProviderService } from '../models/provider-service.model';



import { Observable, ReplaySubject } from 'rxjs';
import { ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OfferService {

  // ReplaySubject to store the latest service
  private service$ = new ReplaySubject<ProviderService[]>(1);

  constructor(private http: HttpClient) {}

  // Expose as observable
  get services(): Observable<ProviderService[]> {
    return this.service$.asObservable();
  }

  // Push new services to the subject
  private addService(service: ProviderService[]): void {
    this.service$.next(service);
  }

  // Fetch service based on params
  getService(params$: Observable<ParamMap>): Observable<ProviderService | undefined> {
    return params$.pipe(
      // Ensure both parameters exist
      filter(params => params.has('providerId') && params.has('offerSlug')),

      // Build URL
      map(params => 
        `${environment.apiUrl}/providers/${params.get('providerId')}/services?expand=provider,children&slug=${params.get('offerSlug')}`
      ),

      // Fetch API data
      switchMap(url => this.http.get<any>(url)),

      // Map response to model
      map(response => {
        if (response._embedded?.service?.[0]) {
          return new ProviderService(response._embedded.service[0]);
        }
        return undefined;
      }),

      // Save it into the subject
      tap(service => {
        if (service) {
          this.addService([service]);
        }
      })
    );
  }
}
